import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "content"]

  connect() {
    // Initialize visibility based on trigger state
    if (this.hasTriggerTarget) {
      this.toggle()
    }
  }

  toggle() {
    if (!this.hasContentTarget) return

    if (this.triggerTarget.type === "checkbox") {
      // For checkboxes, show content when checked
      if (this.triggerTarget.checked) {
        this.show()
      } else {
        this.hide()
      }
    } else if (this.triggerTarget.type === "radio") {
      // For radio buttons, show content when selected
      if (this.triggerTarget.checked) {
        this.show()
      } else {
        this.hide()
      }
    } else {
      // For other elements, toggle visibility
      if (this.contentTarget.classList.contains("hidden")) {
        this.show()
      } else {
        this.hide()
      }
    }
  }

  show() {
    this.contentTarget.classList.remove("hidden")
  }

  hide() {
    this.contentTarget.classList.add("hidden")
  }
}